import AGGREGATOR_ICON from '../assets/images/icons/aggregator.svg'
import APPLICATION_DONE_OUTLINED from '../assets/images/icons/applicationDoneOutlined.svg'
import CALENDAR_FILLED from '../assets/images/icons/calendarFilled.svg'
import CLOCK from '../assets/images/icons/clock.svg'
import COIN_FILLED from '../assets/images/icons/coinFilled.svg'
import CONFETTI_BACKGROUND from '../assets/images/icons/confetti.svg'
import CreditCardOutlined from '../assets/images/icons/creditCardOutlined.svg'
import DELIVERY_TRUCK from '../assets/images/icons/deliveryTruck.svg'
import DocumentCopy from '../assets/images/icons/documentCopy.svg'
import ERROR_RETRY from '../assets/images/icons/errorRetry.svg'
import {
  default as FAST_FOOD_OUTLINED,
  default as FEES_OUTLINED,
} from '../assets/images/icons/fastFoodOutlined.svg'
import GIFT_OUTLINED from '../assets/images/icons/giftOutlined.svg'
import USER_VERIFIED_GREY from '../assets/images/icons/greyUserVerified.svg'
import INPERSON_KYC from '../assets/images/icons/inPersonKYC.svg'
import INFO_ICON from '../assets/images/icons/infoIcon.svg'
import OFFER_FILLED from '../assets/images/icons/offerFilled.svg'
import SUBMITTEDFILLED from '../assets/images/icons/submittedFilled.svg'
import TICK from '../assets/images/icons/tick.svg'
import USER_VERIFIED from '../assets/images/icons/userVerified.svg'
import WORLD_OUTLINED from '../assets/images/icons/worldOutlined.svg'
import APPLICATION from '../assets/images/statusScreens/application.svg'
import CARDS_SUCCESS from '../assets/images/statusScreens/cardsSuccess.svg'
import CLOCK_ARROW_BLUE from '../assets/images/statusScreens/clockArrowBlue.svg'
import CLOCK_ERROR from '../assets/images/statusScreens/clockError.svg'
import CONGRATULATIONS from '../assets/images/statusScreens/congratulations.svg'
import DOCUMENT_CROSS from '../assets/images/statusScreens/documentCross.svg'
import DOCUMENT_PERSON from '../assets/images/statusScreens/documentPerson.svg'
import DOCUMENT_SEARCH from '../assets/images/statusScreens/documentSearch.svg'
import DOCUMENT_WARN from '../assets/images/statusScreens/documentWarn.svg'
import INCORRECT_DETAILS from '../assets/images/statusScreens/editApplication.svg'
import COMPLETED from '../assets/images/statusScreens/kycComplete.svg'
import INCOMPLETE from '../assets/images/statusScreens/kycIncomplete.svg'
import OFFLINE from '../assets/images/statusScreens/kycOffline.svg'
import PROCESSING from '../assets/images/statusScreens/processing.svg'
import REJECTED from '../assets/images/statusScreens/rejected.svg'
import SERVER_ERROR from '../assets/images/statusScreens/retry.svg'
import SUCCESS from '../assets/images/statusScreens/success.svg'
import UNLINKED from '../assets/images/statusScreens/unlinked.svg'
import WARNING from '../assets/images/statusScreens/warning.svg'

export const ICON_MAP = {
  TICK,
  CLOCK,
  OFFLINE,
  ERROR_RETRY,
  COMPLETED,
  INFO_ICON,
  INCOMPLETE,
  REJECTED,
  UNLINKED,
  SERVER_ERROR,
  SUCCESS,
  INCORRECT_DETAILS,
  CONGRATULATIONS,
  PROCESSING,
  CLOCK_ARROW_BLUE,
  CARDS_SUCCESS,
  DOCUMENT_CROSS,
  DOCUMENT_SEARCH,
  DOCUMENT_WARN,
  APPLICATION,
  CLOCK_ERROR,
  COIN_FILLED,
  OFFER_FILLED,
  CALENDAR_FILLED,
  SUBMITTEDFILLED,
  GIFT_OUTLINED,
  FAST_FOOD_OUTLINED,
  FEES_OUTLINED,
  WORLD_OUTLINED,
  APPLICATION_DONE_OUTLINED,
  WARNING,
  DOCUMENT_PERSON,
  AGGREGATOR_ICON,
  INPERSON_KYC,
  CONFETTI_BACKGROUND,
  DELIVERY_TRUCK,
  USER_VERIFIED,
  USER_VERIFIED_GREY,
  CreditCardOutlined,
  DocumentCopy,
} as const
